/**
 * 当前插件仅在搜索组件中使用
 */
import $ from "jquery"
import Qs from "qs"
import { getAllColsUidInLayoutComponent, handleFindLayoutComponentOptions } from "utils"
class searchLayoutComponentClass {
  constructor(val) {
    this.content = val
    this.firstField = "" //一级标签 1:筛选项1  2:筛选项2  3:下拉框
    this.secondField = "" //二级标签
    this.thirdField = "" //三级标签
    this.searchTypeList = ""
    this.selectOptions = []
    this.selectIndex = 0
    this.tabIndex = 0
    this.radioIndex = 0
    this.selectElement = "" // 下拉组件
    this.tabElement = "" // tab组件
    this.radioElement = "" // 单选组件
  }
  async init() {
    const that = this
    const getElement = this.getElementInLayout()
    this.content.$el.style.overflow = "visible"
    const selectCls =
      "container_id_" +
      getElement.searchMsg.container_id +
      "-rect_id_" +
      getElement.searchMsg.rect_id +
      "-uid_" +
      getElement.searchUid +
      "-elementInLayoutId_" +
      getElement.searchElementInLayout[1].elementInLayoutId
    setTimeout(() => {
      $("." + selectCls).css("z-index", 2)
    }, 100)
    let appId = getElement.searchOptions.appId
    if (!appId) return
    this.searchList = await this.getSearchList(appId)
    if (this.searchList == "err") return
    this.firstField = getElement.searchOptions.firstField
    this.secondField = getElement.searchOptions.secondField
    this.thirdField = getElement.searchOptions.thirdField
    this.selectShow = getElement.searchElementInLayout.findIndex(item => {
      return item.searchType === "searchSelect"
    })
    this.tabShow = getElement.searchElementInLayout.findIndex(item => {
      return item.searchType === "searchTabs"
    })
    this.radioShow = getElement.searchElementInLayout.findIndex(item => {
      return item.searchType === "searchRadio"
    })
    this.setSearchList(this.searchList, this.tabIndex, this.radioIndex, this.selectIndex)
    getElement.searchElementInLayout.forEach(element => {
      switch (element.searchType) {
        case "searchTabs":
          this.tabIndex = element.activeIndex
          if (this.firstField == "1") {
            this.selectOptions = element.tabsList
          }
          break
        case "searchSelect":
          if (this.firstField == "3") {
            this.selectIndex = element.selectOptions.findIndex(item => item.label === element.value)
            this.selectOptions = element.selectOptions
          }
          break
        case "searchRadio":
          this.radioIndex = element.activeIndex
          if (this.firstField == "2") {
            this.selectOptions = element.radioLists
          }
          break
        default:
          break
      }
    })
    // 当字段匹配为空时 隐藏相应的组件
    setTimeout(() => {
      this.selectElement = $(
        `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
          getElement.searchUid
        }-elementInLayoutId_${getElement.searchElementInLayout[this.selectShow]?.elementInLayoutId}`
      )
      this.tabElement = $(
        `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
          getElement.searchUid
        }-elementInLayoutId_${getElement.searchElementInLayout[this.tabShow]?.elementInLayoutId}`
      )
      this.radioElement = $(
        `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
          getElement.searchUid
        }-elementInLayoutId_${getElement.searchElementInLayout[this.radioShow]?.elementInLayoutId}`
      )
      if (this.firstField != "1" && this.secondField != "1" && this.thirdField != "1") {
        this.tabElement.hide()
      } else {
        this.tabElement.show()
      }
      if (this.firstField != "2" && this.secondField != "2" && this.thirdField != "2") {
        this.radioElement.hide()
      } else {
        this.radioElement.show()
      }
      if (this.firstField != "3" && this.secondField != "3" && this.thirdField != "3") {
        this.selectElement.hide()
      } else {
        this.selectElement.show()
      }
    }, 100)
    // 点击下拉切换
    this.selectClick()
    // 点击tab切换
    this.tabClick()
    // 点击radio切换 筛选项2是一级菜单的情况
    this.radioClick()
    //监听切换样式
    this.content.$watch(
      "options.encId",
      async function (n, o) {
        if (n !== o && o) {
          that.searchList = await that.getSearchList(appId)
          that.setSearchList(that.searchList, that.tabIndex, that.radioIndex, that.selectIndex)
        }
      },
      { immediate: true }
    )
  }
  // 点击下拉切换
  selectClick() {
    const that = this
    setTimeout(() => {
      $(that.content.$el)
        .find(".cx-select>.el-select .el-select-dropdown__item")
        .on("click", function () {
          if (that.selectIndex == $(this).index()) {
            return
          }
          if (that.firstField == "3") {
            const typeId = that.selectOptions[$(this).index()].value
            that.selectFun(typeId, that.tabIndex, that.radioIndex, $(this).index())
          } else if (that.secondField == "3") {
            // 判断是否需要获取搜索引擎
            if (that.searchTypeList)
              that.setSearchTypeList(that.searchTypeList, that.tabIndex, that.radioIndex, $(this).index())
            else that.setSearchList(that.searchList, that.tabIndex, that.radioIndex, $(this).index())
          }
          that.selectIndex = $(this).index()
          // 切换后重新给tab绑定事件 不然不能点击
          if (that.thirdField != "3") {
            that.tabClick()
            that.radioClick()
          }
        })
    }, 100)
  }
  async selectFun(typeId, index1, index2, index3) {
    const that = this
    that.searchTypeList = await that.getSearchTypeList(typeId)
    if (that.searchTypeList == "err") return
    that.setSearchTypeList(that.searchTypeList, index1, index2, index3)
  }
  // 点击tab切换
  tabClick() {
    const that = this
    setTimeout(() => {
      $(that.content.$el)
        .find(".tab")
        .on("click", function () {
          if (that.tabIndex == $(this).index()) {
            return
          }
          if (that.firstField == "1") {
            that.selectIndex = 0 //重置下拉选中项
            that.radioIndex = 0 //重置单选选中项
            const typeId = that.selectOptions[$(this).index()].value
            that.selectFun(typeId, $(this).index(), that.radioIndex, that.selectIndex)
          } else if (that.secondField == "1") {
            // 判断是否需要获取搜索引擎
            if (that.searchTypeList)
              that.setSearchTypeList(that.searchTypeList, $(this).index(), that.radioIndex, that.selectIndex)
            else that.setSearchList(that.searchList, $(this).index(), that.radioIndex, that.selectIndex)
          }
          that.tabIndex = $(this).index()
          // 切换后重新绑定事件 不然不能点击
          if (!(that.thirdField == "1")) {
            that.selectClick()
            that.radioClick()
          }
        })
    }, 100)
  }
  // 点击radio切换
  radioClick() {
    const that = this
    setTimeout(() => {
      $(that.content.$el)
        .find(".radio")
        .on("click", function () {
          if (that.radioIndex == $(this).index()) {
            return
          }
          if (that.firstField == "2") {
            const typeId = that.selectOptions[$(this).index()].value
            that.selectFun(typeId, that.tabIndex, $(this).index(), that.selectIndex)
          } else if (that.secondField == "2") {
            // 判断是否需要获取搜索引擎
            if (that.searchTypeList.length > 0)
              that.setSearchTypeList(that.searchTypeList, that.tabIndex, $(this).index(), that.selectIndex)
            else that.setSearchList(that.searchList, that.tabIndex, $(this).index(), that.selectIndex)
          }
          that.radioIndex = $(this).index()
          // 切换后重新绑定事件 不然不能点击
          if (that.thirdField != "2") {
            that.selectClick()
            that.tabClick()
          }
        })
    }, 100)
  }

  // 获取数据
  async getSearchList(appId) {
    return new Promise((resolve, reject) => {
      this.content.$API
        .querySearchEngineList({
          appId: appId
        })
        .then(res => {
          // let data = require("./sql.json")
          if (res.data.code === 1) {
            if (res.data.data) resolve(res.data.data.datas)
            else resolve([])
          } else {
            reject("err")
          }
        })
    })
  }
  // 查询引擎下分类
  async getSearchTypeList(typeId) {
    return new Promise((resolve, reject) => {
      this.content.$API
        .querySearchEngineClassify({
          typeId: typeId
        })
        .then(res => {
          // let data = require("./type.json")
          if (res.data.code === 1) {
            resolve(res.data.data.searchTypeList)
          } else {
            reject("err")
          }
        })
    })
  }
  // 获取搜索基本组件
  getElementInLayout() {
    const searchMsg = {
      container_id: this.content.myid.container_id,
      rect_id: this.content.myid.rect_id,
      elementInAutoLayoutId: this.content.myid.elementInAutoLayoutId,
      path: this.content.myid.path
    }
    const rectAttr = this.content.getRectAttribute.call(this.content, searchMsg)
    const searchOptions = [rectAttr.options.rows[0]]
    const searchUid = getAllColsUidInLayoutComponent(searchOptions)[0]
    const searchElementInLayout = handleFindLayoutComponentOptions(searchOptions, searchUid)
    return {
      searchOptions: rectAttr.options,
      searchMsg: searchMsg,
      searchUid: searchUid,
      searchElementInLayout: searchElementInLayout
    }
  }
  // 渲染搜索引擎组件基本信息
  setSearchList(searchList, tabIndex, radioIndex, selectIndex) {
    if (searchList.length === 0) return
    const getElement = this.getElementInLayout()
    const selectList = []
    if (Array.isArray(searchList)) {
      searchList.forEach(item => {
        selectList.push({
          label: item.name,
          value: item.encId,
          link: item.link,
          name: item.name,
          content: item.id
        })
      })
    }
    getElement.searchElementInLayout.forEach(element => {
      if (this.firstField == "3") {
        switch (element.searchType) {
          case "searchSelect":
            this.content.$changeOptionsEV(selectList, "selectOptions", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            // 返回第一个搜索引擎的值
            let label = selectList.length > 0 ? (selectList[0] ? selectList[0].label : selectList[0].label) : ""
            this.content.$changeOptionsEV(label, "value", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      } else if (this.firstField == "1") {
        switch (element.searchType) {
          case "searchTabs":
            this.content.$changeOptionsEV(selectList, "tabsList", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      } else if (this.firstField == "2") {
        switch (element.searchType) {
          case "searchRadio":
            this.content.$changeOptionsEV(selectList, "radioLists", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      }
    })
    let listIdx = 0
    if (this.firstField == "1") {
      listIdx = tabIndex
    } else if (this.firstField == "2") {
      listIdx = radioIndex
    } else if (this.firstField == "3") {
      listIdx = selectIndex
    }
    this.setSearchTypeList(searchList[listIdx].searchTypeList, tabIndex, radioIndex, selectIndex)
  }
  // 渲染引擎下的分类
  setSearchTypeList(list, tabIndex, radioIndex, selectIndex = 0) {
    const getElement = this.getElementInLayout()
    const searchTypeList = []
    const subSearchTypeList = []
    let linkUrl = ""
    if (Array.isArray(list)) {
      list.forEach(item => {
        searchTypeList.push({
          name: item.name,
          content: item.id,
          label: item.name,
          value: item.encId,
          link: item.link
        })
      })
      if (list[tabIndex] && list[tabIndex].link) {
        linkUrl = list[tabIndex].link
      }
    }
    let selectElement = $(
      `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
        getElement.searchUid
      }-elementInLayoutId_${getElement.searchElementInLayout[this.selectShow]?.elementInLayoutId}`
    )
    let tabElement = $(
      `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
        getElement.searchUid
      }-elementInLayoutId_${getElement.searchElementInLayout[this.tabShow]?.elementInLayoutId}`
    )
    let radioElement = $(
      `.container_id_${getElement.searchMsg.container_id}-rect_id_${getElement.searchMsg.rect_id}-uid_${
        getElement.searchUid
      }-elementInLayoutId_${getElement.searchElementInLayout[this.radioShow]?.elementInLayoutId}`
    )
    let secondIndex = 0
    let thirdIndex = 0
    if (this.secondField == "1") {
      secondIndex = tabIndex
    } else if (this.secondField == "2") {
      secondIndex = radioIndex
    } else if (this.secondField == "3") {
      secondIndex = selectIndex
    }
    if (this.thirdField == "1") {
      thirdIndex = tabIndex
    } else if (this.thirdField == "2") {
      thirdIndex = radioIndex
    } else if (this.thirdField == "3") {
      thirdIndex = selectIndex
    }
    if (list[secondIndex] && Array.isArray(list[secondIndex].subSearchTypeList)) {
      list[secondIndex].subSearchTypeList.forEach(item => {
        subSearchTypeList.push({
          name: item.name,
          content: item.id,
          label: item.name,
          value: item.encId,
          link: item.link
        })
      })
      if (list[secondIndex].subSearchTypeList[thirdIndex] && list[secondIndex].subSearchTypeList[thirdIndex].link) {
        linkUrl = list[secondIndex].subSearchTypeList[thirdIndex].link
      }
    }
    getElement.searchElementInLayout.forEach(element => {
      switch (element.searchType) {
        case "searchInput":
          linkUrl = linkUrl + "&sw=" + encodeURIComponent(element.inputValue)
          break
        case "searchButton":
          this.content.$changeOptionsEV(linkUrl, "linkUrl", false, null, {
            uid: getElement.searchUid,
            elementInLayoutId: element.elementInLayoutId,
            ...getElement.searchMsg
          }, true)
          break
        default:
          break
      }
      // 二级标签
      if (this.secondField == "1") {
        if (searchTypeList.length > 0) {
          tabElement.show()
        } else {
          tabElement.hide()
        }
        switch (element.searchType) {
          case "searchTabs":
            this.content.$changeOptionsEV(searchTypeList, "tabsList", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      } else if (this.secondField == "2") {
        if (searchTypeList.length > 0) {
          radioElement.show()
        } else {
          radioElement.hide()
        }
        switch (element.searchType) {
          case "searchRadio":
            this.content.$changeOptionsEV(searchTypeList, "radioLists", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      } else if (this.secondField == "3") {
        if (searchTypeList.length > 0) {
          selectElement.show()
        } else {
          selectElement.hide()
        }
        switch (element.searchType) {
          case "searchSelect":
            this.content.$changeOptionsEV(searchTypeList, "selectOptions", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            let label =
              searchTypeList.length > 0
                ? searchTypeList[selectIndex]
                  ? searchTypeList[selectIndex].label
                  : searchTypeList[0].label
                : ""
            // 返回第一个搜索引擎的值
            this.content.$changeOptionsEV(label, "value", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      }
      // 三级标签
      if (this.thirdField == "1") {
        if (subSearchTypeList.length > 0) {
          tabElement.show()
        } else {
          tabElement.hide()
        }
        switch (element.searchType) {
          case "searchTabs":
            this.content.$changeOptionsEV(subSearchTypeList, "tabsList", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(tabIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break

          default:
            break
        }
      } else if (this.thirdField == "2") {
        if (subSearchTypeList.length > 0) {
          radioElement.show()
        } else {
          radioElement.hide()
        }
        switch (element.searchType) {
          case "searchRadio":
            this.content.$changeOptionsEV(subSearchTypeList, "radioLists", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            this.content.$changeOptionsEV(radioIndex, "activeIndex", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      } else if (this.thirdField == "3") {
        if (subSearchTypeList.length > 0) {
          selectElement.show()
        } else {
          selectElement.hide()
        }
        switch (element.searchType) {
          case "searchSelect":
            this.content.$changeOptionsEV(subSearchTypeList, "selectOptions", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            // 返回第一个搜索引擎的值
            let label =
              subSearchTypeList.length > 0
                ? subSearchTypeList[selectIndex]
                  ? subSearchTypeList[selectIndex].label
                  : subSearchTypeList[0].label
                : ""
            this.content.$changeOptionsEV(label, "value", false, null, {
              uid: getElement.searchUid,
              elementInLayoutId: element.elementInLayoutId,
              ...getElement.searchMsg
            }, true)
            break
          default:
            break
        }
      }
    })
  }
}
export default {
  data() {
    return {
      searchLayoutComponentClass: new searchLayoutComponentClass(this)
    }
  },
  methods: {
    async searchComponentPlugin() {
      await this.searchLayoutComponentClass.init()
    }
  }
}
